const enum PermissionType {
    AREA = 1,
    FAMILY = 2,
    PERMISSION = 3,
}

export default PermissionType;